const Modes = {
  PORTFOLIO: 'portfolio_mode',
  COACH: 'coach_mode',
  EDITOR: 'editor_mode',
  ADMIN: 'admin_mode',
  PLATFORM_SETTINGS: 'platform_settings_mode'
};

export default Modes;
